module.exports = __webpack_public_path__ + "static/fonts/SanFranciscoDisplayBold.57fe104.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/SanFranciscoDisplayBold.woff2
// module id = RO9V
// module chunks = 1